<template>
  <Modal
    :disabled="false"
    :modal-heading="''"
    :modal-open="isOpen"
    :toggle-modal="() => toggleModal(false)"
    :class-name="'comment-media'"
  >
    <MediaGallery v-if="isOpen" :pages="pages" :image-url="imageUrl" />
  </Modal>
</template>

<script>
import Modal from 'Components/Modal.vue';
import MediaGallery from './MediaGallery.vue';

export default {
  name: 'FuneralProgramModal',

  components: {
    MediaGallery,
    Modal,
  },

  props: {
    isOpen: {
      required: true,
      type: Boolean,
    },
    toggleModal: {
      required: true,
      type: Function,
    },
    imageUrl: {
      required: true,
      type: String,
    },
    pages: {
      required: true,
      type: Number,
    },
  },
};
</script>
